// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1T8Vq","dragIcon":"Choice_dragIcon__3Gejt","left":"Choice_left__1XRKb","input":"Choice_input___DeFz"};